import "./Dev.css";

import { Store } from "@reduxjs/toolkit";

export const stores: Record<number, Store> = {};
